import { KnowledgeEvents } from "./knowledge";
import { GeneralEvents } from "./general";
import { ReportEvents } from "./report";
import { OpportunitiesEvents } from "./opportunities";
import { SimulatorEvents } from "./simulator";
import { IntegrationEvents } from "./integration";
import { QualityEvents } from "./quality";
import { ExploreEvents } from "./explore";
import { InteractionInformationEvents } from "./interactionInformation";
import { AuthEvents } from "./auth";
import { NavigationEvents } from "./navigation";

type PostHogEvents =
  | KnowledgeEvents
  | GeneralEvents
  | ReportEvents
  | OpportunitiesEvents
  | SimulatorEvents
  | IntegrationEvents
  | QualityEvents
  | ExploreEvents
  | InteractionInformationEvents
  | AuthEvents
  | NavigationEvents;

declare global {
  interface Window {
    posthog: any;
  }
}

export const posthogSetUserProps = (properties: Record<string, any>) => {
  if (typeof window !== 'undefined' && window.posthog) {
    window.posthog.identify(properties.id, properties);
  }
};

export const posthogRegisterSuperProps = (properties: Record<string, any>) => {
  if (typeof window !== 'undefined' && window.posthog) {
    window.posthog.register(properties);
  }
};

export const posthogUnregisterSuperProps = (properties: string[]) => {
  if (typeof window !== 'undefined' && window.posthog) {
    properties.forEach((property) => {
      window.posthog.unregister(property);
    });
  }
};

export const posthogTrackEvent = ({
  event,
  properties,
}: {
  event: PostHogEvents;
  properties?: Record<string, any>;
}) => {
  if (typeof window !== 'undefined' && window.posthog) {
    window.posthog.capture(`quack_${event}`, properties || {});
  }
};

export const posthogTrackPageView = (page: string, properties?: Record<string, any>) => {
  if (typeof window !== 'undefined' && window.posthog) {
    window.posthog.capture('$pageview', {
      $current_url: window.location.href,
      page,
      ...properties,
    });
  }
};

export {
  KnowledgeEvents,
  GeneralEvents,
  ReportEvents,
  OpportunitiesEvents,
  SimulatorEvents,
  IntegrationEvents,
  QualityEvents,
  ExploreEvents,
  InteractionInformationEvents,
  AuthEvents,
  NavigationEvents,
};